import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=49c79c86&scoped=true&"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=49c79c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c79c86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
